import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

const OnLeaveDetail = ({ data }) => {
  const [datum, setDatum] = useState({});

  useEffect(() => {
    if (data && data.length) {
      setDatum(data[0].attributes);
    }
  }, [data]);

  return (
    <>
      <div className="font-weight-bold text-secondary">Type</div>
      <div>{datum.leaveType}</div>

      <div className="font-weight-bold text-secondary">Begin Date</div>
      <div>{format(datum.leaveDateDt, 'MM/DD/YYYY')}</div>

      <div>via {datum.sourceDescription}</div>
    </>
  );
};

OnLeaveDetail.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    attributes: PropTypes.shape(),
  })).isRequired,
};

export default OnLeaveDetail;
